import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from '../../../../key-registry'
import { fetchTransitOperationInfoV2 } from './http'

export async function fetchTransitOperationInfo(id: number, opts?: { signal?: AbortSignal }) {
  return fetchTransitOperationInfoV2(id, opts)
}

export function useFetchTransitOperationInfo(transitOperationId: number | null, isAdmin: boolean) {
  return useQuery({
    enabled: !!transitOperationId && isAdmin,
    queryKey: QueryKeys.transitOperationInfo.detail(transitOperationId),
    queryFn: ({ signal }) => fetchTransitOperationInfo(transitOperationId as number, { signal }),
    staleTime: Infinity,
  })
}
